import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { forViewer, teamMembersQuery, viewerIdOf } from "../services/queries";

export const useTeamMembers = () => {
  const { user, token } = useAuth();

  return useQuery({
    ...forViewer(teamMembersQuery(user?.schoolId, user?.soid, token), viewerIdOf(user)),
    enabled: !!user?.schoolId && !!token,
    refetchOnWindowFocus: false,
  });
};
